import React, { Component, Fragment } from 'react'
import Header from '../partials/Header';
import Footer from '../partials/Footer';
import { Col, Container, Row, FormGroup, Label, Form, Button, Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

export class AddPayConfirmCard extends Component {
    render() {
        return (
            <Fragment>
                <Header {...this.props} path={["Home", "Cart"]} heading="Add Payment Method" />
                <Container className="margin-top-fix mb-5 text-white-1">
                    <Row className="add-payment-container bg-dark-1 justify-content-center">
                        
                            <h5>Payment Method</h5>
                            <div className="pay-method-container bg-dark-2 mt-4">
                                <Col xl={6} lg = {8} md = {11} sm = {12}>
                                    <Row className="justify-content-between">

                                        {/* <div className="d-flex">
                                            <input type="radio" />
                                            <h6 className="mx-3">Paypal</h6>
                                            <div className="pay-logo paypal-logo ms-auto"></div>
                                            </div>
                                            <div className="d-flex mt-3">
                                                <input type="radio" checked />
                                                <h6 className="mx-3">Credit Card Or Debit Card</h6>
                                                <div className="pay-logo visa-logo ms-auto"></div>
                                            </div> */}

                                        <Col lg={4} md={3} sm={3} className="d-flex">
                                            <input type="radio" />
                                            <h6 className="mx-3">Paypal</h6>
                                        </Col>
                                        <Col xl={2} lg={3} md={3} sm={4} xs={4} className = "p-sm-0">
                                            <div className="pay-logo paypal-logo"></div>
                                        </Col>
                                    </Row>
                                    <Row className="justify-content-between mt-3">
                                        <Col lg={7} md={7} sm={8} className="d-flex">
                                            <input type="radio" checked />
                                            <h6 className="mx-3">Credit Card Or Debit Card</h6>
                                        </Col>
                                        <Col xl = {3} lg={3} md={3} sm={4} xs={5} className = "p-sm-0">
                                            <div className="pay-logo visa-logo"></div>
                                        </Col>
                                    </Row>
                                </Col>
                                <div className="add-pay-card-container">
                                    <Form>
                                        <Row>
                                            <Col xl = {6} lg={6} sm = {12}>
                                                <FormGroup >
                                                    <Label>Card Number</Label>
                                                    <input type="number" className="form-control mt-2" placeholder="1235 5675 8971 4567" style={{ borderRadius: 16 }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xl ={6} lg={6}>
                                                <FormGroup className = "mt-3 mt-lg-0">
                                                    <Label>Name On Card</Label>
                                                    <input type="text" className="form-control mt-2" placeholder="Name" style={{ borderRadius: 16 }} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="justify-content-start mt-4">
                                            <Col xl = {2} lg = {3} md={6}>
                                                <FormGroup>
                                                    <Label>Expiry Date</Label>
                                                    <input type="number" className="form-control mt-2" placeholder="MM/YY" style={{ borderRadius: 16 }} />
                                                </FormGroup>
                                            </Col>
                                            <Col xl = {2} lg={3} md={6}>
                                                <FormGroup className = "mt-3 mt-md-0">
                                                    <Label>CVC/CVV</Label>
                                                    <input type="number" className="form-control mt-2" placeholder="..." style={{ borderRadius: 16 }} />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg= {7}>
                                                <div className="card-remember">
                                                    <FormGroup className="d-flex">
                                                        <input type="checkbox" className="mt-1" />
                                                        <p className="ms-4 text-grey-1">Your Transaction Is Secured with SSL Encrption.</p>
                                                    </FormGroup>
                                                    <FormGroup className="d-flex">
                                                        <input type="checkbox" className="mt-1" />
                                                        <p className="ms-4 text-grey-1">Remember This for future payments</p>
                                                    </FormGroup>
                                                    <FormGroup className="d-flex">
                                                        <input type="checkbox" className="mt-1" />
                                                        <p className="ms-4 text-grey-1">I Read And Agree
                                                    <span className="text-purple-1"> <b><u>Terms And Conditions</u></b> </span> And
                                                    <span className="text-purple-1"> <b><u>Refund Policy</u></b></span>
                                                        </p>
                                                    </FormGroup>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Col lg={5}>
                                            <Button block className="w-100 bg-purple-1 border-0 py-4 " style={{ borderRadius: 16 }}>Confirm Card</Button>
                                        </Col>
                                    </Form>
                                </div>

                            </div>
                        
                    </Row>
                </Container>
                <Footer />
            </Fragment>
        )
    }
}

export default AddPayConfirmCard
